import {Component, Input} from '@angular/core';
import { CoreMenu } from '@core/types';

@Component({
  selector: '[core-menu-horizontal-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuHorizontalItemComponent {
  @Input() item: CoreMenu;
}
